import { render, staticRenderFns } from "./InviteResendModal.vue?vue&type=template&id=2ce5a4bd"
import script from "./InviteResendModal.vue?vue&type=script&lang=js"
export * from "./InviteResendModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports